import React from 'react';
import { Text } from '@fluentui/react-components';

interface TenantPrefixBoxProps {
  /** The tenant's configured label prefix. When empty/undefined, an em dash is shown. */
  prefix?: string;
}

/**
 * Shared read-only "Tenant prefix" pill shown beside the page subtitle in the
 * Tenant Sensitivity Labels (View 1) and Tenant Policy Deployment (View 2) headers.
 * Always renders; shows an em dash when no prefix is configured.
 */
export const TenantPrefixBox: React.FC<TenantPrefixBoxProps> = ({ prefix }) => {
  return (
    <div
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        padding: '6px 12px',
        border: '1px solid #0078d4',
        borderRadius: 6,
        background: '#eff6fc',
      }}
      title="Parent and standalone labels are deployed with this prefix; child labels are not prefixed."
    >
      <Text size={200} style={{ color: '#0078d4' }}>
        Tenant prefix
      </Text>
      <Text size={300} style={{ fontWeight: 700, color: '#0078d4' }}>
        {prefix || '—'}
      </Text>
    </div>
  );
};

export default TenantPrefixBox;
